module.exports = __webpack_public_path__ + "static/media/slices_1.14782625.jpg";